/**
 * El idioma de todo lo que la app formatea: fechas, horas, números y listas.
 *
 * Cada `toLocale…`, `Intl.*` y `localeCompare` de la PWA lo pasa explícito. Sin
 * esto, el formato sale del idioma del navegador, y una persona mayor con el
 * teléfono en inglés leería "11/3" en vez de "3 de noviembre". Vale para el
 * texto que arma la app; el selector nativo de `type="date"` lo dibuja el
 * sistema, con el idioma del teléfono, y eso la app no lo puede cambiar.
 */
export const LOCALE = 'es-AR';
